import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Text, Button } from '@mantine/core';
import MyUserContext from './../myUserContext.js';
import { listSavedTexts } from './../offlineStore.js';

// What the app shows without network on any page but the reader: the
// books saved for offline, each one tap from where you stopped.
const OfflineHome = () => {
  const myUser = useContext(MyUserContext);
  const language = myUser ? myUser.myUserSettings.lang : 'ru';
  const t = (ru, en) => (language === 'ru' ? ru : en);
  const [texts, setTexts] = useState(null);
  useEffect(() => {
    listSavedTexts().then((l) => {
      // Turn stored cover Blobs into object URLs so the <img> src can
      // use them. URLs live as long as this component — released in the
      // cleanup below.
      const urls = [];
      const enriched = l.map((x) => {
        if (x.coverBlob) {
          const u = URL.createObjectURL(x.coverBlob);
          urls.push(u);
          return { ...x, _coverSrc: u };
        }
        return { ...x, _coverSrc: x.cover };
      });
      enriched.sort((a, b) => (b.lastOpenedAt || 0) - (a.lastOpenedAt || 0));
      setTexts(enriched);
      // No cleanup needed on unmount — the object URLs are released
      // when the page is navigated away and the global holder is GC'd.
      return () => urls.forEach((u) => URL.revokeObjectURL(u));
    });
  }, []);

  return (
    <div className="mx-auto max-w-xl w-full px-4 py-8">
      <Text fw={700} size="lg" ta="center">{t('Вы офлайн', 'You are offline')}</Text>
      <Text size="sm" c="dimmed" ta="center" mt={4}>
        {t('Лента, поиск и чаты появятся, когда вернётся сеть. Сохранённые книги можно читать сейчас.', 'Feed, search and chats return with the network. Saved books can be read now.')}
      </Text>
      {texts === null ? null : texts.length === 0 ? (
        <Text size="sm" c="dimmed" ta="center" mt="xl">
          {t('Сохранённых книг нет. В читалке есть кнопка «Сохранить для офлайна».', 'No saved books. The reader has a "Save for offline" button.')}
        </Text>
      ) : (
        <div className="flex flex-col gap-2 mt-6">
          {texts.map((x) => {
            const pct = x.progress && x.paragraphCount ? Math.round(x.progress.position / x.paragraphCount * 100) : 0;
            return (
              <Link key={x.id} to={`/arts/${x.artId}/read/${x.id}`} className="flex items-center gap-3 p-2 rounded-xl" style={{ background: 'var(--mantine-color-default)', color: 'inherit', textDecoration: 'none' }}>
                {x._coverSrc ? <img src={x._coverSrc} alt="" className="rounded-md object-cover flex-shrink-0" style={{ width: 44, height: 66 }} /> : <div className="rounded-md flex-shrink-0" style={{ width: 44, height: 66, background: 'var(--mantine-color-default-border)' }} />}
                <div className="flex-1 min-w-0">
                  <div className="font-semibold leading-snug" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{x.artName || x.label}</div>
                  <Text size="xs" c="dimmed" className="truncate">{[x.author, x.label].filter(Boolean).join(' · ')}</Text>
                  {!x.complete && <Text size="xs" c="orange">{t('Сохранено не полностью', 'Partly saved')}</Text>}
                </div>
                <Button size="xs" radius="xl" component="span">{pct > 0 ? `${t('Продолжить', 'Continue')} · ${pct}%` : t('Читать', 'Read')}</Button>
              </Link>
            );
          })}
        </div>
      )}
      <div className="flex justify-center mt-8">
        <Button variant="default" size="sm" onClick={() => window.location.reload()}>{t('Проверить сеть', 'Retry')}</Button>
      </div>
    </div>
  );
};

export default OfflineHome;
